import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Avatar, Typography, IconButton, Skeleton, Stack } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import { useGithub } from '../../hooks/useGithub';
import { SOCIAL_MEDIA_LINKS } from '../../utils/constants';
import GithubSearchBar from '../GIthubSearchBar/GithubSearchBar';
import AppTab from '../AppTab/AppTab';
import './GithubAppBar.css';

export default function GitHubAppBar() {
    const { user } = useGithub();
    const [imageError, setImageError] = useState(false);
  
    return (
        <AppBar position="fixed" elevation={0} className="github-appbar">
            <Stack direction="column" className="github-appbar-stack">
                <Toolbar className="github-appbar-toolbar">
                    <Box className="github-appbar-user">
                        {user && !imageError ? (
                            <Avatar
                                src={user.avatarUrl}
                                alt={user.username}
                                onError={() => setImageError(true)}
                                className="github-avatar"
                            />
                        ) : (
                            <Skeleton variant="circular" width={32} height={32} />
                        )}
                        <Typography variant="s1" noWrap className="github-username">
                            {user?.username || <Skeleton width={80} />}
                        </Typography>
                    </Box>

                    <Box className="github-appbar-actions">
                        <GithubSearchBar options={[]}/>
                        <IconButton color="inherit" component="a" href={SOCIAL_MEDIA_LINKS.linkedin} target="_blank" className="icon-button">
                            <LinkedInIcon fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" component="a" href={user?.profileUrl} target="_blank" className="icon-button">
                            <GitHubIcon fontSize="small" />
                        </IconButton>
                        <IconButton color="inherit" component="a" href={SOCIAL_MEDIA_LINKS.email} className="icon-button">
                            <EmailIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Toolbar>

                <Box className="github-appbar-tabs">
                    <AppTab />
                </Box>
            </Stack>
        </AppBar>
    );
}
